import 'bootstrap/dist/css/bootstrap.css';
import Dictionary from './Dictionary';
import './App.css';

function App() {
  return (
    <div className="App">
    <Dictionary />  
    
    </div>
  );
}

export default App;
